import { VerticalSlug } from './types'

export interface VerticalAvailabilityBadgeProps {
  stock?: number
  vertical?: VerticalSlug
  className?: string
}

export function VerticalAvailabilityBadge({
  stock = 0,
  vertical = 'otro',
  className = '',
}: VerticalAvailabilityBadgeProps) {
  // Verticals where warehouse stock doesn't apply
  if (vertical === 'salud') {
    return (
      <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold bg-emerald-100 text-emerald-800 ${className}`}>
        Agenda Activa
      </span>
    )
  }

  if (vertical === 'inmobiliaria') {
    return (
      <span
        className={`text-[10px] px-2 py-0.5 rounded-full font-bold ${
          stock > 0
            ? 'bg-emerald-100 text-emerald-800'
            : 'bg-amber-100 text-amber-800'
        } ${className}`}
      >
        {stock > 0 ? 'Disponible' : 'Reservado / En trámite'}
      </span>
    )
  }

  if (vertical === 'belleza_estetica') {
    return (
      <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold bg-pink-100 text-pink-800 ${className}`}>
        Turnos Disponibles
      </span>
    )
  }

  if (vertical === 'servicios') {
    return (
      <span className={`text-[10px] px-2 py-0.5 rounded-full font-bold bg-blue-100 text-blue-800 ${className}`}>
        Disponible
      </span>
    )
  }

  if (vertical === 'turismo_posadas') {
    return (
      <span
        className={`text-[10px] px-2 py-0.5 rounded-full font-bold ${
          stock > 0
            ? 'bg-teal-100 text-teal-800'
            : 'bg-red-100 text-red-700'
        } ${className}`}
      >
        {stock > 0 ? 'Cupos Disponibles' : 'Sin Cupos'}
      </span>
    )
  }

  // Inventory / Standard verticals
  return (
    <span
      className={`text-[10px] px-2 py-0.5 rounded-full font-bold ${
        stock > 10
          ? 'bg-green-100 text-green-700'
          : stock > 0
          ? 'bg-amber-100 text-amber-700'
          : 'bg-red-100 text-red-700'
      } ${className}`}
    >
      {stock > 0 ? `STOCK: ${stock}` : 'SIN STOCK'}
    </span>
  )
}
